<div class="kt-header kt-grid__item kt-header--fixed" id="kt_header">
  <!-- <ngb-progressbar class="kt-loading-bar" *ngIf="(loader.progress$|async) > 0" [value]="loader.progress$|async" height="3px"></ngb-progressbar> -->
  <div class="kt-header__top">
    <div class="kt-container my-auto container-xl mx-auto">
      <!-- brand comp -->
      <div class="kt-header__brand kt-grid__item" id="kt_header_brand">
        <div class="kt-header__brand-logo">
          <a href="javascript:;" routerLink="/">
            <img alt="logo" src="assets/media/logos/racebet365.png" height="42" class="kt-header__brand-logo-default" />
            <img alt="logo" src="assets/media/logos/racebet365.png" height="34" class="kt-header__brand-logo-sticky" />
          </a>
        </div>
      </div>

      <div class="kt-header__topbar" *ngIf="false">
        <div class="kt-header__topbar-item kt-header__topbar-item--quick-panel">
          <div class="kt-header__topbar-wrapper">
            <span class="kt-header__topbar-icon" id="kt_quick_panel_toggler_btn">
              <span class="fa fa-euro-sign text-warning"> </span>
              <span class="ml-3 text-warning">0.00 {{authService.currentCurrency$ | async | uppercase}}</span>
            </span>
          </div>
        </div>
      </div>

      <div class="kt-header__topbar d-none d-md-block">
        <div class="text-md-right text-sm-center text-center my-auto pr-0">
          <div class="logged-user d-none d-md-block" *ngIf="isLogin">
            <button
              *ngIf="canQuickDeposit"
              type="button"
              class="btn-quick-deposit"
              (pointerdown)="prefetchDepositModal()"
              (click)="quickDeposit()"
            >
              <i class="fas fa-wallet"></i>
              <span>{{ "TND_PAYMENT.DEPOSIT_TITLE" | translate }}</span>
            </button>
            <a routerLink="/account/transactions">
              {{ "AUTH.GENERAL.MY_ACCOUNT" | translate }}
            </a>
            <a *ngIf="isLogin" routerLink="/account/profile"><i class="fas fa-user"></i> {{ username }}</a>
            <a><i class="fas fa-money-bill"></i>
              {{ balance | number:'1.2-2' }} {{authService.currentCurrency$ | async | uppercase}}  
            </a>
            <a (click)="logOut()"><i class="fas fa-sign-out-alt" pTooltip=" {{ 'HOME.LOGOUT' | translate }}"></i></a>
          </div>
          <div ngbDropdown #myDrop="ngbDropdown" [placement]="'bottom-right'" class="dropdown dropdown-inline">
            <button *ngIf="!isLogin" class="btn btn-warning btn-md ml-1" (click)="login()">
              {{ "HOME.LOGIN" | translate }}
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="mobile-sticky">
    <div class="kt-header mobile-header">
      <div class="container-fluid">
        <div class="row flex-nowrap align-items-center">
          <div class="col logo-col">
            <a routerLink="/">
              <img alt="logo" src="assets/media/logos/racebet365.png" />
            </a>
          </div>
          <div class="col-auto text-right my-auto mobile-icons mr-2">
            <div class="logged-user" *ngIf="isLogin;else login_btn">
              <button
                *ngIf="canQuickDeposit"
                type="button"
                class="btn-quick-deposit btn-quick-deposit-sm"
                (pointerdown)="prefetchDepositModal()"
              (click)="quickDeposit()"
                [attr.aria-label]="'TND_PAYMENT.DEPOSIT_TITLE' | translate"
              >
                <i class="fas fa-wallet"></i>
                <span class="d-none d-sm-inline">{{ "TND_PAYMENT.DEPOSIT_TITLE" | translate }}</span>
              </button>
              <a routerLink="/account/transactions" class="mr-0">
                {{ balance | number:'1.2-2' }} {{authService.currentCurrency$ | async | uppercase}}  
                <!-- {{ userBalance | number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}} -->
              </a>
              <i class="menu-icon fa fa-user" (click)="toggleSidebar(0)"></i>
            </div>
            <ng-template #login_btn>
              <button class="btn btn-warning btn-md ml-1 btn-login-mobile" (click)="login()">
                <span class="login-label-full">{{ "HOME.LOGIN" | translate }}</span>
                <span class="login-label-short">{{ "HOME.LOGIN_SHORT" | translate }}</span>
              </button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="kt-header__bottom margin-header">
    <div class="kt-container px-0 px-md-3">
      <div class="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
        <div class="kt-header-menu kt-header-menu-mobile" id="kt_header_menu">
          <ul class="kt-menu__nav">
            <li class="kt-menu__item kt-menu__item--rel" [class.kt-menu__item--here]="router.url.includes('homepage')">
              <a class="kt-menu__link kt-menu__toggle" routerLink="/" routerLinkActive="active-link"
                [routerLinkActiveOptions]="{ exact: true }">
                <i class="kt-menu__link-icon fa fa-home"></i>
                <span class="kt-menu__item-here"></span>
                <span class="kt-menu__link-text">
                  {{ "MENU.HOME" | translate }}
                </span>
              </a>
            </li>
            <li class="kt-menu__item kt-menu__item--rel" [class.kt-menu__item--here]="router.url.includes('races')">
              <a class="kt-menu__link kt-menu__toggle" routerLink="/races/pmu" routerLinkActive="active-link">
                <img class="mr-1" src="../../../../assets/media/icons/pmu_races.webp" />
                <span class="kt-menu__item-here"></span>
                <span class="d-none d-md-block kt-menu__link-text">
                  {{ "MENU.PMU_RACES" | translate }}
                </span>
                <span class="d-sm-block d-md-none kt-menu__link-text">
                  {{ "MENU.PMU_RACES_SHORT" | translate }}
                </span>
              </a>
            </li>
            <li class="kt-menu__item kt-menu__item--rel" [class.kt-menu__item--here]="router.url.includes('races')">
              <a class="kt-menu__link kt-menu__toggle" routerLink="/races/all" routerLinkActive="active-link">
                <i class="kt-menu__link-icon fa fa-flag"></i>
                <span class="kt-menu__item-here"></span>
                <span class="d-none d-md-block kt-menu__link-text">
                  {{ "MENU.ALL_RACES" | translate }}
                </span>
                <span class="d-sm-block d-md-none kt-menu__link-text">
                  {{ "MENU.ALL_RACES_SHORT" | translate }}
                </span>
              </a>
            </li>
            <li class="kt-menu__item kt-menu__item--rel"
              [class.kt-menu__item--here]="router.url.includes('next-races')">
              <a class="kt-menu__link kt-menu__toggle" routerLink="/next-races/all" routerLinkActive="active-link">
                <i class="kt-menu__link-icon fa fa-angle-double-right"></i>
                <span class="kt-menu__item-here"></span>
                <span class="d-none d-md-block kt-menu__link-text">
                  {{ "MENU.NEXT_RACES" | translate }}
                </span>
                <span class="d-sm-block d-md-none kt-menu__link-text">
                  {{ "MENU.NEXT_RACES_SHORT" | translate }}
                </span>
              </a>
            </li>
            <li
              class="kt-menu__item kt-menu__item--rel"
              *ngIf="canSeeVirtuals$ | async"
              [class.kt-menu__item--here]="router.url.includes('virtuals')">
              <a class="kt-menu__link kt-menu__toggle" routerLink="/virtuals" routerLinkActive="active-link">
                <i class="kt-menu__link-icon fas fa-gamepad"></i>
                <span class="kt-menu__item-here"></span>
                <span class="kt-menu__link-text">
                  {{ "MENU.VIRTUALS" | translate }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</div>

<p-toast position="bottom-right"></p-toast>
<p-toast key="generic-toaster" position="bottom-right"></p-toast>
<p-toast key="bell-toaster" position="top-left" styleClass="bell-toaster">
  <ng-template let-message pTemplate="message">
    <span class="p-toast-message-icon pi pi-bell"></span>
    <div class="p-toast-message-text">
      <div class="p-toast-summary" [innerHTML]="message.summary"></div>
      <div class="p-toast-detail" [innerHTML]="message.detail"></div>
    </div>
  </ng-template>
</p-toast>